<template>
  <h1 class="page-title">
    {{ label }}<slot />
  </h1>
</template>

<script>
export default {
    name: 'PageTitle',
    props: {
        label: { type: String, default: '' },
    },
};
</script>

<style lang="scss" scoped>
.page-title {
    margin-bottom: 50px;
}
</style>
